import React, { useEffect, useState } from "react";
import { PublicHeader, PublicFooter } from "@/components/PublicShell";
import { api } from "@/lib/api";
import { FileText, DownloadSimple, ShieldCheck } from "@phosphor-icons/react";

const DOCUMENT_FIELDS = [
  { key: "darpan", label: "Darpan Registration Certificate" },
  { key: "pan", label: "PAN Card" },
  { key: "reg_80g", label: "80G Certificate" },
];

/**
 * Donor-facing proof-of-authenticity page. Not linked from any nav/menu —
 * shared manually as a direct URL (seva-india.org/donate/documents) with
 * donors who want to verify the organisation before giving.
 */
export default function DocumentsPage() {
  const [docs, setDocs] = useState(null);

  useEffect(() => {
    api.get("/documents").then((r) => setDocs(r.data)).catch(() => setDocs({}));
  }, []);

  return (
    <>
      <PublicHeader />
      <section className="max-w-3xl mx-auto px-5 md:px-10 py-16">
        <div className="fade-up text-center mb-10">
          <div className="w-16 h-16 rounded-full bg-[#E6F3DC] text-[#2F7A4A] grid place-items-center mx-auto mb-5">
            <ShieldCheck size={32} weight="fill" />
          </div>
          <h1 className="font-display font-bold text-3xl md:text-4xl mb-3">NGO Verification Documents</h1>
          <p className="text-[#56624F] text-lg">
            View our official registration documents below to verify SEVA&rsquo;s authenticity as a registered non-profit.
          </p>
        </div>

        <div className="space-y-4">
          {DOCUMENT_FIELDS.map(({ key, label }) => {
            const doc = docs?.[key];
            const available = !!doc?.url;
            return (
              <div key={key} className="seva-card flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-11 h-11 rounded-xl bg-[#F5F8F2] text-[#2F7A4A] grid place-items-center shrink-0">
                    <FileText size={22} />
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold">{label}</div>
                    <div className="text-xs text-[#56624F]">{available ? "Available for verification" : "Not yet uploaded"}</div>
                  </div>
                </div>
                {available && (
                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-secondary inline-flex items-center justify-center gap-2 shrink-0"
                    data-testid={`document-${key}-view`}
                  >
                    <DownloadSimple size={16} /> View
                  </a>
                )}
              </div>
            );
          })}
        </div>

        <p className="text-sm text-[#56624F] mt-10 text-center">
          If you have any questions about these documents or our registration, please reach out to us directly.
        </p>
      </section>
      <PublicFooter />
    </>
  );
}
